(function () {
  'use strict';

  angular.module('ringbaPortal').component('prpV2', {
    bindings: {
      prpDetails: '<'
    },
    controller: PrpV2Controller,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/auth/v2/prpv2.view.html'
  });

  function PrpV2Controller(
    $stateParams,
    cacheService,
    whitelabelService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    function onInit() {
      _checkPreviewMode();
      vm.isWhitelabeledSite = !whitelabelService.checkLocationHostIsBase() || $stateParams.preview == 'true';
      vm.prpId = $stateParams.prpId;
    }

    function _checkPreviewMode() {
      if ($stateParams.preview) {
        vm.previewModeEnabled = true;
        vm.currentTheme = cacheService.get('prp-register-preview');
        vm.isLightTheme = vm.currentTheme && vm.currentTheme.isLightTheme;
        cacheService.remove('prp-register-preview');
      }
    }
  }
})();
